module.exports = __webpack_public_path__ + "img/stop_bleeding_full.f08d7086.jpg";